<template>
  <div class="audience-list-table">
    <div class="file-download-buttons"><a class="download-button csv" @click="showSendCSV">全参加者CSV</a><a class="download-button pdf" @click="showSendPDF">全参加者PDF</a></div>
    <div class="loading-box" v-if="showLoading">
      <loading></loading>
    </div>
    <div class="search-result-title">
      <div class="search-result-title-box search-result-title-play-dates" v-show="selected_play_dates.length > 0" v-for="(play_date, index) in selected_play_dates" :key="`play_date-${index}`">
        {{ play_date | formatDate }}
      </div>
      <div class="search-result-title-box search-result-title-ticket-type-name" v-show="selected_ticket_types.length > 0 && selected_ticket_types[0].hasOwnProperty('id')" v-for="(ticket, index) in selected_ticket_types" :key="`ticket-${index}`">
        {{ ticket.name }}
      </div>
      <div class="search-result-title-box search-result-title-ticket-type-name" v-if="selected_ticket_types.length == 0 || selected_ticket_types[0] == ''">すべてのチケット</div>
      <div class="search-result-title-box search-result-title-payment-status" v-show="payment_status.length > 0" v-for="(status, index) in payment_status" :key="`payment_status-${index}`">
        {{ status.label }}
      </div>
      <div class="search-result-title-box search-result-title-payment-method" v-show="payment_method.length > 0" v-for="(method, index) in payment_method" :key="`payment_method-${index}`">
        {{ method.label }}
      </div>
    </div>
    <div class="search-result-title-and-mobile-menu-btn">
      <span class="audience-count">{{ delimitThreeDigits(totalAudienceCount) }}枚</span>
      <div class="mobile-menu-btn">
        <label class="select-disp-menu js-option-label">
          <span class="select-disp-menu-title" @click="openPaymentSearchModal">絞り込み</span>
        </label>
      </div>
    </div>
    <div class="search-result-total-amount">
      <ul>
        <li><span>支払額合計</span> {{ '¥' + delimitThreeDigits(totalAudienceAmount) }}</li>
        <li><span>手数料合計</span> {{ '¥' + delimitThreeDigits(totalAudienceFeeAll) }}</li>
        <li><span>振込額合計</span> {{ '¥' + delimitThreeDigits(totalAudienceTransfer) }}</li>
      </ul>
    </div>
    <div class="perpage-select-num-box">
      <div class="perpage-select-row">
        <p class="perpage-select-title">表示数：</p>
        <div class="select-disp-num">
          <label class="select-disp-label js-option-label" for="select-disp-label" @click="changeShowDispNum(true)"
            >{{ perPage }}件
            <div class="arrow-down"></div
          ></label>
          <ul class="select-disp-num-dropdown" v-if="is_show_disp_num == true">
            <li v-for="(number, index) in perPageSelects" :value="number" :key="index" :data-per-page="number" @click="setPerPage($event)">{{ number }}件</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table id="js-table" class="table">
        <thead id="js-head">
          <tr>
            <th class="audience_list_label__no">
              <div class="receipt-no-label" @click="sortAudience('receipt_no')">
                受付番号
                <div class="arrow-down"></div>
              </div>
            </th>
            <th class="audience_list_label__name">ニックネーム/メール</th>
            <th class="audience_list_label__volume">枚数</th>
            <th class="audience_list_label__payment_status">ステータス</th>
            <th class="audience_list_label__play_dates">開催日</th>
            <th class="audience_list_label__ticket_types">チケット</th>
            <th class="audience_list_label__payment_method">支払方法</th>
            <th class="audience_list_label__fee_burden">販売手数料</th>
            <template v-if="event_use_introducer">
              <template v-for="(eq, index) in event_questionnaires">
                <th class="audience_list_label__introducer_text" :key="eq.id">{{ eq.introducer_text }}</th>
              </template>
            </template>
            <template v-if="use_introducer_tell">
              <th class="audience_list_label__introducer_tel">電話番号</th>
            </template>
            <template v-if="use_introducer_adress">
              <th class="audience_list_label__introducer_adress">住所</th>
            </template>
            <template v-if="use_introducer_name">
              <th class="audience_list_label__introducer_name">氏名</th>
            </template>
            <th class="audience_list_label__note">備考</th>
            <th class="audience_list_label__amount">支払額</th>
            <th class="audience_list_label__fee">手数料</th>
            <th class="audience_list_label__transfer">振込額</th>
            <th class="audience_list_label__entry_at">申込日時</th>
            <th class="audience_list_label_menu"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(audience, index) in items" :key="index">
            <td class="audience_list_label__no">
              <span v-if="audience.is_divided_all" class="audience_no">全分配</span>
              <span v-else class="audience_no">{{ audience.receipt_no }}</span>
              <p v-if="audience.is_divide_ticket" class="divide_annotation">分配受取</p>
              <p v-if="audience.is_divide_percial && !audience.is_divided_all" class="divide_annotation">一部分配</p>
            </td>
            <td class="audience_list_label__name">
              <span class="audience-name">{{ audience.name }}</span>
              <span class="audience-email">{{ audience.email }}</span>
            </td>
            <td class="audience_list_label__volume">
              <span class="audience_volume">{{ audience.volume }}</span>
            </td>
            <td class="audience_list_label__payment_status">
              {{ audience.payment_status }}
            </td>
            <td class="audience_list_label__play_dates">
              <template v-if="audience.is_albirex_event != true">
                <span v-for="(play_date, index) in audience.play_dates" :key="index">
                  <span class="audience_play_date">{{ play_date }}</span>
                </span>
              </template>
              <template v-else>
                <span class="audience_play_date">{{ audience.albirex_event_play_dates }}</span>
              </template>
            </td>
            <td class="audience_list_label__ticket_types">
              {{ audience.ticket_type_name }}
            </td>
            <td class="audience_list_label__payment_method">
              {{ audience.payment_method }}
            </td>
            <td class="audience_list_label__fee_burden">
              {{ audience.fee_burden }}
            </td>
            <template v-if="event_use_introducer">
              <template v-for="(eq, index) in event_questionnaires">
                <td v-if="audience.event_questionnaire_answers.length > index" class="audience_list_label__introducer_text" :key="index">
                  {{ audience.event_questionnaire_answers[index].introducer }}
                </td>
                <td v-else class="audience_list_label__introducer_text" :key="index">
                  未回答
                </td>
              </template>
            </template>
            <template v-if="use_introducer_tell">
              <td class="audience_list_label__introducer_tel">
                {{ audience.introducer_tell }}
              </td>
            </template>
            <template v-if="use_introducer_adress">
              <td class="audience_list_label__introducer_adress">
                {{ audience.introducer_adress }}
              </td>
            </template>
            <template v-if="use_introducer_name">
              <td class="audience_list_label__introducer_name">
                {{ audience.introducer_name }}
              </td>
            </template>
            <td class="audience_list_label__note">{{ audience.note }}</td>
            <td class="audience_list_label__amount_column">
              {{ audience.amount }}
            </td>
            <!-- CP中・GoToイベントは設定しない -->
            <template v-if="audience.cancel == true && !audience.is_refund_fee_audience">
              <td class="audience_list_label__fee_column">
                {{ audience.audience_burden_fee }}
              </td>
            </template>
            <template v-else>
              <td class="audience_list_label__fee_column">
                {{ audience.fee_all }}
              </td>
            </template>
            <td class="audience_list_label__transfer_column">
              {{ audience.transfer_column }}
            </td>
            <td class="audience_list_label__entry_at">{{ audience.entry_at }}</td>
            <td class="audience_list_label_menu">
              <span class="menu-btn-label-edit" @click="openEditAudienceModal(audience)">編集</span>
              <span v-if="!audience.is_divide_ticket" class="menu-btn-label-refund" :class="{ 'menu-btn-label-refund canceled': audience.cancel == true || is_can_not_refund_event == true || audience.main_event_can_refund === false }" @click="handleRefundClick(audience)">払い戻し</span>
              <span v-if="!audience.is_divide_ticket" class="menu-btn-label-block" @click="openBlockAudienceModal(audience)">{{ blockLbl(audience.is_blocked) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="paginete-for-audience-list">
      <paginate ref="paginator" :page-count="getPaginateCount" :prev-text="'前へ'" :next-text="'次へ'" :click-handler="paginateClickCallback" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
    </div>
    <div class="payment-search-modal">
      <payment-search-modal :get_audiences_path="get_audiences_path" v-if="is_show_payment_search_modal == true" @close-btn-click="closePaymentSearchModal" @open-loading="openLoading" @close-loading="closeLoading"></payment-search-modal>
    </div>
    <div class="confirm-modal-for-file">
      <confirm-modal-for-file :eventer_mail="eventer_mail" :main_event_title="main_event_title" :file_format="file_format" :send_file_api_path="send_file_api_path" v-if="showConfirmModalForFile == true" @close-btn-click="closeConfirmModalForFile" @offShowConfirmModalForFile="offShowConfirmModalForFile"></confirm-modal-for-file>
    </div>
    <div class="edit-audience-modal">
      <edit-audience-modal v-if="showEditAudienceModal == true" @close-btn-click="closeEditAudienceModal" :audience="editAudience" :editAudienceIsSubAudience="editAudienceIsSubAudience" :event_introducer_text="event_introducer_text" :event_questionnaires="event_questionnaires" :edit_audience_path="edit_audience_path" :recapcha_api_key="recapcha_api_key"></edit-audience-modal>
    </div>
    <div class="refund-audience-modal">
      <refund-audience-modal
        v-if="showRefundAudienceModal == true"
        @close-btn-click="closeRefundAudienceModal"
        :audience="editAudience"
        :recapcha_api_key="recapcha_api_key"
        :refund_message="refund_message"
        :main_event_title="main_event_title"
        :main_event_play_date="main_event_play_date"
        :event_use_introducer="event_use_introducer"
        :event_introducer_text="event_introducer_text"
        :event_questionnaires="event_questionnaires"
        :use_introducer_name="use_introducer_name"
        :use_introducer_adress="use_introducer_adress"
        :use_introducer_tell="use_introducer_tell"
        :event_place="event_place"
        :event_url="event_url"
        :contact_info="contact_info"
        :inquiry_url="inquiry_url"
        :edit_audience_path="edit_audience_path"
        :main_event_id="main_event_id"
        @open-loading="openLoading"
        @close-loading="closeLoading"
        :use_contact_form="use_contact_form"
        :contact_mails="contact_mails"
        :contact_tels="contact_tels"
        :contact_urls="contact_urls"
      ></refund-audience-modal>
      <div class="refund-audience-modal">
        <block-audience-modal
          v-if="showBlockAudienceModal == true"
          @close-btn-click="closeBlockAudienceModal"
          :audience="editAudience"
          :exclamation_img_path="exclamation_img_path"
          :comment_img_path="comment_img_path"
          :block_audience_path="block_audience_path"
          :main_event_id="main_event_id"
        ></block-audience-modal>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentSearchCheckboxes from './PaymentSearchCheckboxes.vue';

export default {
  components: { PaymentSearchCheckboxes },
  props: {
    selectedPaymentStatus: Array,
    searchData: Array,
    get_audiences_path: { type: String, required: true },
    event_use_introducer: { type: Boolean, required: true },
    event_introducer_text: { type: String, required: true },
    event_questionnaires: { type: Array, required: true },
    use_introducer_tell: { type: Boolean, required: true },
    use_introducer_name: { type: Boolean, required: true },
    use_introducer_adress: { type: Boolean, required: true },
    send_csv_path: { type: String, required: true },
    eventer_mail: { type: String, required: true },
    send_pdf_path: { type: String, required: true },
    main_event_title: { type: String, required: true },
    edit_audience_path: { type: String, required: true },
    recapcha_api_key: { type: String, required: true },
    refund_message: { type: String, required: true },
    main_event_play_date: { type: String, required: true },
    event_place: { type: String, required: true },
    event_url: { type: String, required: true },
    contact_info: { type: String, required: true },
    inquiry_url: { type: String, required: true },
    main_event_id: { type: Number, required: true },
    is_cooperator: { type: Boolean, required: true },
    is_can_not_refund_event: { type: Boolean, required: true },
    exclamation_img_path: { type: String, required: true },
    comment_img_path: { type: String, required: true },
    block_audience_path: { type: String, required: true },
    use_contact_form: { type: Boolean, required: true },
    contact_mails: { type: String, required: true },
    contact_tels: { type: String, required: true },
    contact_urls: { type: String, required: true },
  },
  data() {
    return {
      perPageSelects: [100, 500, 1000],
      is_show_disp_num: false,
      is_show_payment_search_modal: false,
      sortOrder: 1,
      showConfirmModalForFile: false,
      showLoading: false,
      audienceMenuItems: [
        { value: 'edit', label: '編集' },
        { value: 'refund', label: '払い戻し' },
        { value: 'block', label: '通報' },
      ],
      showEditAudienceModal: false,
      editAudience: null,
      editAudienceIsSubAudience: false,
      showRefundAudienceModal: false,
      file_format: '',
      send_file_api_path: '',
      scrollPosition: 0,
      showBlockAudienceModal: false,
    };
  },
  created() {
    this.getAudiences();
  },
  mounted() {
    const _this = this;
    $(window).on('click', function (e) {
      _this.changeShowDispNum(false);
    });
    // 処理の重複防止
    $('.js-option-label').on('click', function (e) {
      e.stopPropagation();
    });
  },
  computed: {
    audiences: function () {
      return this.$store.getters['audience/getAudiencesFromEvent'];
    },
    items: function () {
      return this.audiences;
    },
    getPaginateCount: function () {
      if (this.perPage === 0) {
        return 1;
      } else {
        return Math.ceil(this.totalAudienceCount / this.perPage);
      }
    },
    selected_play_dates: function () {
      return this.$store.getters['audience/getPlayDates'];
    },
    selected_ticket_types: function () {
      return this.$store.getters['audience/getTicketTypes'];
    },
    payment_status: function () {
      return this.$store.getters['audience/getPaymentStatus'];
    },
    payment_method: function () {
      return this.$store.getters['audience/getPaymentMethods'];
    },
    currentPage: function () {
      return this.$store.getters['audience/getCurrentPage'];
    },
    perPage: function () {
      return this.$store.getters['audience/getPerPage'];
    },
    totalAudienceCount: function () {
      return this.$store.getters['audience/getTotalAudienceCount'];
    },
    totalAudienceAmount: function () {
      return this.$store.getters['audience/getTotalAudienceAmount'];
    },
    totalAudienceFeeAll: function () {
      return this.$store.getters['audience/getTotalAudienceFeeAll'];
    },
    totalAudienceTransfer: function () {
      return this.$store.getters['audience/getTotalAudienceTransfer'];
    },
  },
  methods: {
    async getAudiences() {
      const isAdmissionPage = false;
      this.showLoading = true;
      await this.$store.dispatch('audience/getAudiences', { api_path: this.get_audiences_path, t: '', isAdmissionPage }).catch((error) => {
        alert('エラーが発生しました。時間をおいてから改めてお試しください。');
      });
      this.showLoading = false;
    },
    paginateClickCallback: function (pageNum) {
      this.setCurrentPage(Number(pageNum));
    },
    changeShowDispNum: function (is_show) {
      this.is_show_disp_num = is_show;
    },
    setPerPage: function (event) {
      const perPage = event.target.dataset.perPage === 0 ? 0 : parseInt(event.target.dataset.perPage);
      this.$store.commit('audience/setPerPage', perPage);
      // 1ページ目の場合はaudiencesを取得
      // それ以外の場合はcurrentPageを書き換える(書き換え先でaudiencesを取得)
      if (this.currentPage == 1) {
        this.getAudiences();
      } else {
        this.setCurrentPage(1);
      }
    },
    setCurrentPage: function (pageNum) {
      this.$store.commit('audience/setCurrentPage', pageNum);
      this.getAudiences();
    },
    openPaymentSearchModal() {
      this.is_show_payment_search_modal = true;
      this.hideBackground();
    },
    closePaymentSearchModal() {
      this.is_show_payment_search_modal = false;
      this.showBackground();
    },
    sortAudience(sortKey) {
      this.sortOrder *= -1;
      this.$store.commit('audience/sortAudiences', {sortOrder: this.sortOrder, sortKey: sortKey});
    },
    // デリミタ処理
    delimitThreeDigits(data) {
      const target = String(data);
      return target.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    showSendCSV() {
      this.file_format = 'CSV';
      this.showConfirmModalForFile = true;
      this.hideBackground();
      this.send_file_api_path = this.send_csv_path;
    },
    showSendPDF() {
      this.file_format = 'PDF';
      this.showConfirmModalForFile = true;
      this.hideBackground();
      this.send_file_api_path = this.send_pdf_path;
    },
    closeConfirmModalForFile() {
      this.showConfirmModalForFile = false;
      this.showBackground();
    },
    openLoading() {
      this.showLoading = true;
    },
    closeLoading() {
      this.showLoading = false;
    },
    openEditAudienceModal(audience) {
      this.setScrollPosition();
      this.editAudience = audience;
      this.editAudienceIsSubAudience = audience.is_divide_ticket;
      this.showEditAudienceModal = true;
      this.hideBackground();
    },
    closeEditAudienceModal() {
      this.showEditAudienceModal = false;
      this.showBackground();
    },
    openRefundAudienceModal(audience) {
      this.setScrollPosition();
      this.editAudience = audience;
      if (this.is_can_not_refund_event == true) {
        alert('イベント終了後5日経過しているため払い戻しはできません。');
      } else if (this.is_cooperator == true) {
        alert('共同主催者様は「払い戻し」ができません。イベント主催者様のみ可能です。');
      } else if (audience.payment_status == '払い戻し') {
        alert('すでに払い戻し済みのチケットです');
      } else if (audience.payment_method == 'コンビニ払い') {
        alert('コンビニ支払いのチケットは払い戻しできません。');
      } else {
        this.showRefundAudienceModal = true;
        this.hideBackground();
      }
    },
    closeRefundAudienceModal() {
      this.showRefundAudienceModal = false;
      this.showBackground();
      this.restoreScrollPosition();
    },
    hideBackground() {
      document.body.style.overflow = 'hidden';
    },
    showBackground() {
      document.body.style.overflow = '';
    },
    setScrollPosition() {
      this.scrollPosition = window.pageYOffset;
    },
    restoreScrollPosition() {
      window.scrollTo({ top: this.scrollPosition });
    },
    // 子コンポネートからフラグを変更するためのメソッド
    offShowConfirmModalForFile() {
      this.showConfirmModalForFile = false;
    },
    openBlockAudienceModal(audience) {
      this.setScrollPosition();
      this.editAudience = audience;
      this.showBlockAudienceModal = true;
      this.hideBackground();
    },
    closeBlockAudienceModal() {
      this.showBlockAudienceModal = false;
      this.showBackground();
    },
    blockLbl(is_block) {
      return is_block ? "通報済み" : "通報";
    },
    handleRefundClick(audience) {
      if (audience.cancel == true || this.is_can_not_refund_event == true || audience.main_event_can_refund === false) {
        return
      }
      this.openRefundAudienceModal(audience);
    }
  },
  watch: {
    currentPage: function(newVal){
      if (newVal == 1) this.$refs.paginator.selectFirstPage();
    }
  },
  filters: {
    formatDate(dateStr) {
      const year = dateStr.slice(0, 4);
      const month = parseInt(dateStr.slice(4, 6), 10);
      const day = parseInt(dateStr.slice(6), 10);
      return `${year}年${month}月${day}日`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;

.audience-list-table {
  width: 100%;
  line-height: 1em;

  @media screen and (max-width: 1140px) {
    max-width: calc(100% - 20px);
  }

  @media screen and (max-width: $break-point) {
    max-width: 100%;
  }

  .file-download-buttons {
    margin-bottom: 31px;
    text-align: right;

    @media screen and (max-width: 1140px) {
      justify-content: right;
      margin-right: 30px;
    }

    @media screen and (max-width: $break-point) {
      justify-content: right;
      margin-right: 20px;
      margin-bottom: 20px;
    }

    a {
      color: $shop-blue;
      cursor: pointer;
      font-size: 15px;

      @media screen and (max-width: $break-point) {
        font-size: 13px;
      }
    }

    .csv {
      margin-right: 10px;
    }
  }

  .search-result-title {
    display: flex;
    flex-wrap: wrap;
    row-gap: 5px;
    color: $shop-navy;
    font-size: 18px;
    font-weight: 600;

    @media screen and (max-width: $break-point) {
      margin-right: 20px;
      font-weight: 600;
      font-size: 15px;
      margin-left: 20px;
    }

    .search-result {
      padding: 0 5px;
    }
  }

  .search-result-title-box {
    line-height: 1;
    white-space: nowrap;
    margin-right: 5px;
    padding-right: 5px;
    border-right: 1px solid $shop-lightgray;

    &:last-child {
      margin-right: 0;
      padding-right: 0;
      border-right: none;
    }
  }

  .search-result-title-and-mobile-menu-btn {
    display: flex;
    margin-top: 10px;

    @media screen and (max-width: $break-point) {
      justify-content: space-between;
      margin-top: 18px;
    }

    .audience-count {
      font-size: 18px;
      font-weight: 600;
      min-width: 10px;

      @media screen and (max-width: $break-point) {
        margin-left: 20px;
      }
    }
    .mobile-menu-btn {
      display: none;

      .select-disp-menu-title {
        color: $shop-navy;
        font-size: 13px;
        border: 1px solid $shop-lightgray;
        border-radius: 4px;
        padding: 9px 10px 8px;
      }

      @media screen and (max-width: 768px) {
        display: block;
        margin-right: 20px;
      }
    }
  }

  .search-result-total-amount {
    margin-bottom: 15px;

    @media screen and (max-width: $break-point) {
      margin-left: 20px;
    }

    @media screen and (max-width: 525px) {
      margin-bottom: 0;
      margin-left: 20px;
    }
    ul {
      display: flex;
      margin-top: 15px;

      @media screen and (max-width: 525px) {
        flex-wrap: wrap;
        margin-top: 17px;
      }
      li {
        font-size: 15px;
        &:nth-child(2) {
          margin: 0 20px;

          @media screen and (max-width: 525px) {
            margin: 0;
          }
        }
        &:nth-child(3) {
          @media screen and (max-width: 525px) {
            margin-top: 10px;
          }
        }
        @media screen and (max-width: 525px) {
          width: 50%;
        }
        span {
          color: $gray;
          margin-right: 5px;
          font-size: 14px;
        }
      }
    }
  }

  .perpage-select-num-box {
    display: inline-block;
    text-align: right;
    width: 100%;
    height: 20px;
    margin-bottom: 15px;
    padding-right: 10px;

    @media screen and (max-width: $break-point) {
      margin-top: 36px;
    }
    @media screen and (max-width: 525px) {
      margin-top: 20px;
    }

    .perpage-select-row {
      display: inline-flex;
      align-items: flex-end;
      font-size: 13px;

      @media screen and (max-width: $break-point) {
        justify-content: right;
      }

      .perpage-select-title {
        color: #000;
      }
      .perpage-select-form {
        height: auto;
        border: none;
        padding: 0;
        color: $shop-navy;
        font-size: 14px;
      }
    }

    .select-disp-num {
      display: inline-flex;
      align-items: flex-end;

      label {
        margin: 0;
        cursor: pointer;
        gap: 4px;
      }

      ul li {
        color: $shop-navy;
      }
    }
  }

  .table-responsive {
    border-left: none;
    border-right: none;
    border-bottom: none;

    @media screen and (max-width: $break-point) {
      margin-bottom: 0;
      border-top: 1px solid $event_main-hr-gray;
    }

    thead tr {
      background-color: $shop-input-gray;

      .audience_list_label__no,
      .audience_list_label__name {
        background-color: $shop-input-gray;
      }
    }
  }

  tbody > tr > td .audience-email,
  tbody > tr > td .audience-name {
    white-space: nowrap;
  }

  .audience-email {
    overflow: hidden;
    word-break: break-all;
    font-size: 12px;
    max-width: 400px;
  }

  .audience_list_label__name {
    span {
      display: block;
    }
  }

  .audience_list_label__play_dates span {
    display: block;
  }

  .audience_list_label_menu {
    color: $shop-blue;

    span {
      margin-right: 15px;
      cursor: pointer;
    }

    .canceled {
      color: $shop-lightgray;
    }
  }

  // bootstrapのデフォルトスタイル打ち消し
  .table > thead > tr > th {
    border-bottom: none;
    border-top: 1px solid $event_main-hr-gray;

    @media screen and (max-width: 991px) {
      border-top: none;
    }
  }

  .table > tbody > tr > td {
    border-top: none;
    font-size: 15px;
    padding: 15px 32px 17px 8px;
  }

  .table > tbody > tr > td:last-child {
    padding: 15px 0 17px 8px;
  }

  .table > tbody > tr {
    border-top: 1px solid $event_main-hr-gray;
  }
  .table > tbody > tr:last-child {
    border-bottom: 1px solid $event_main-hr-gray;
  }

  .table {
    max-width: unset;
  }

  th {
    width: 0;
    height: 12px;
    white-space: nowrap;
    text-align: left;
    color: $gray;
    opacity: 1;
    font-weight: 600;
    font-size: 12px;
    padding-top: 12px;
    padding-bottom: 14px;

    @media screen and (max-width: $break-point) {
      padding: 6px 40px 9px 7px;
      font-weight: 700;
    }
  }

  tbody > tr > .audience_list_label__no {
    @media screen and (max-width: $break-point) {
      padding-left: 20px !important;
    }
  }

  .audience_list_label__no {
    position: sticky;
    left: 0;
    background-color: #fff;
    padding-right: 20px;

    @media screen and (max-width: $break-point) {
      padding-left: 20px;
    }

    .divide_annotation {
      font-size: 12px;
      color: $gray;
      text-align: center;
      padding-top: 10px;
    }
  }

  .audience_list_label__name {
    background-color: #fff;

    @media screen and (max-width: $break-point) {
      position: unset;
    }
  }

  .receipt-no-label {
    color: $shop-navy;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;

    .arrow-down {
      content: '';
      width: 7px;
      height: 7px;
      border-top: 1px solid $shop-navy;
      border-left: 1px solid $shop-navy;
      transform: translateY(-50%) rotate(-135deg);
      pointer-events: none;
      margin-left: 5px;
      margin-top: 5px;
    }
  }

  td {
    width: 0;
    height: 46px;
    white-space: nowrap;
  }

  tbody > tr > td {
    vertical-align: middle;
    height: 15px;
    text-align: left;
    color: #000;
  }

  .select-disp-num {
    position: relative;
    height: 25px;
    align-items: center;

    .select-disp-label {
      display: flex;
      align-items: center;
      color: $shop-navy;
    }

    ul {
      display: block;
      text-align: left;
      cursor: pointer;
      background-color: #fff;
      box-shadow: 0 0 10px $shadow-black;
      list-style: none;
      position: absolute;
      width: 180px;
      border-radius: 6px;
      top: 18px;
      right: 4px;

      a,
      li {
        padding-left: 10px;
        line-height: 35px;
        color: $shop-gray;
        font-size: 15px;
        opacity: 1;

        &:hover {
          background-color: $shop-page-title-gray;
        }
      }
    }

    .arrow-down {
      content: '';
      width: 7px;
      height: 7px;
      border-top: 1px solid $allow-down-gray;
      border-left: 1px solid $allow-down-gray;
      transform: translateY(-50%) rotate(-135deg);
      pointer-events: none;
      margin-left: 5px;
      margin-top: 5px;
    }
  }

  .paginete-for-audience-list {
    text-align: center;

    .pagination {
      margin: 30px;
    }

    ul.pagination {
      background: #fff;

      & ::v-deep li > a {
        color: #000;
        border: 1px solid $shop-lightgray;
        border-radius: 4px;
        margin-right: 5px;
        font-size: 13px;
      }

      & ::v-deep .active > a {
        color: #fff;
        background: $gray;
      }
    }
  }
  .loading-box {
    background-color: #000;
    opacity: 0.8;
    z-index: 999;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;

    .pg-performer-events--loader {
      position: fixed;
      top: 25%;
      left: 50%;
      z-index: 9999;
    }
  }
}
</style>
